export default __webpack_public_path__ + "static/media/reloadDark.35b0831c.svg";